import type { NDateLocale } from './enUS'
import { fi } from 'date-fns/locale'

const dateFiFI: NDateLocale = {
  name: 'fi-FI',
  locale: fi
}

export default dateFiFI
